var classTypes = [
    {"name": "عمومی", id: 0},
    {"name": "اختیاری", id: 1},
    {"name": "رایگان", id: 2},
];

export default classTypes;